// extracted by mini-css-extract-plugin
export default {"container":"StriveUsers_container__f3Dzz","text":"StriveUsers_text__U4S3a","title":"StriveUsers_title__oLlMi","createButton":"StriveUsers_createButton__-dEcr"};